import { z } from "zod";
import { Color } from "../shared/colors";
import { BaseProgressBarConfig, BaseProgressBarDefaultConfig, } from "../shared/config";
import { defineOverlay } from "../shared/functions";
export const scrollerPositions = ["bottom", "top"];
export const textColors = [
    Color.LIGHT_AQUA,
    Color.LIGHT_GREEN,
    Color.DARK_GREEN,
    Color.LIGHT_YELLOW,
    Color.DARK_YELLOW,
    Color.MEDIUM_GREY,
];
export const MaxProgressBar = defineOverlay({
    defaults: {
        ...BaseProgressBarDefaultConfig,
        scrollerPosition: "bottom",
        textColor: Color.MEDIUM_GREY,
    },
    details: {
        category: "progress",
        description: "Utilize our dynamic Max Progress Bar overlay to enhance your Tiltify fundraising campaign. This overlay stretches the full width of your stream, tracks your progress and recognizes donors.",
        features: [
            "Stretches full width of stream",
            "Fundraising amount",
            "Goal",
            "Donors, milestones and rewards displayed in scroller",
            "Milestones display every 10 minutes",
            "Fits most games",
        ],
        flags: {
            isFeatured: false,
            isNew: false,
            isUpdated: false,
            isVisible: true,
        },
        icon: "progress-bars/max.png",
        name: "Max Progress Bar",
        obsDimensions: {
            height: "90px",
            width: "1920px",
        },
        path: "/overlays/max",
        shortDescription: "This progress bar stretches the full width of your stream, tracks your progress and recognizes donors.",
        shortName: "Max",
        slug: "max",
    },
    schema: BaseProgressBarConfig.extend({
        scrollerPosition: z
            .enum(scrollerPositions)
            .default(() => MaxProgressBar._config.defaults.scrollerPosition)
            .optional(),
        textColor: z
            .enum(textColors)
            .default(() => MaxProgressBar._config.defaults.textColor)
            .optional(),
    }),
});
//# sourceMappingURL=max.js.map